<template>
  <section
    :style="{
      bottom: animationButton.position.bottom + '%',
      left: animationButton.position.left + '%'
    }"
    class="animation-button"
    @click="animationSelected"
  >
    <p class="font--semibold animation-button__title">{{ animationButton.name }}</p>
  </section>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  name: "animation-button",
  props: [
    "animationButton",
    "panAndZoomTo",
    "findMask",
    "ambientAnimationTimeout",
    "removeAnimationTimeout"
  ],

  methods: {
    ...mapMutations([
      "updateShowButtons",
      "updateIsNotZoomedHighlight",
      "setVoiceOver",
      "updateAnimationPlaying",
      "setDelay",
      "updateShowMacroAnimation",
      "updateCurrentProductId",
      "setProductIconsToReveal",
      "updateShowButtons",
      "updateShowProductCard",
      "updatePreviousProductId",
      "updateShowAmbientAnimations",
      "updateCurrentAnimation",
      "clearMicroAnimationsPlaying"
    ]),
    ...mapActions([
      "getIntroTextBox",
      "findMacroAnimation",
      "removeFirstProductCard",
      "removeProductIconsToReveal"
    ]),
    animationSelected() {
      this.updateCurrentAnimation(this.animationButton.name);
      this.$ga.event({
        eventCategory: "Macro Animation",
        eventAction: "Selected",
        eventLabel: "SELECTED: " + this.animationButton.name,
        eventValue: 1
      });
      clearTimeout(this.ambientAnimationTimeout);
      clearTimeout(this.removeAnimationTimeout);
      this.clearMicroAnimationsPlaying();
      this.updateShowAmbientAnimations(false);
      this.setDelay(false);
      this.updateShowProductCard(false);
      setTimeout(() => {
        this.createVoiceOver(this.animationButton.voiceOver).then(() => {
          this.findMacroAnimation(this.animationButton.parentNumId);
          this.getIntroTextBox();
          this.voiceOver.play();
          this.updateShowButtons(false);
          this.updateIsNotZoomedHighlight(true);
          this.updateShowMacroAnimation(true);
          this.findMask(this.animationButton.ref);
          this.setProductIconsToReveal([]);
          this.updateCurrentProductId(null);
          this.updateAnimationPlaying(true);
          if (this.previousProductId) {
            this.removeProductIconsToReveal(this.previousProductId);
            this.updatePreviousProductId(null);
          }
        });
      }, 0);
    },
    createVoiceOver(audio) {
      return new Promise((resolve, reject) => {
        this.setVoiceOver(new Audio("/voice-overs/" + audio));
        resolve();
      });
    },
    clearVoiceOver() {
      this.setVoiceOver(undefined);
    }
  },
  computed: {
    ...mapState({
      showProductCard: state => state.productBar.showProductCard,
      showButtons: state => state.textBox.showButtons,
      delay: state => state.textBox.delay,
      productCards: state => state.productBar.productCards,
      voiceOver: state => state.audio.voiceOver,
      isZoomed: state => state.panZoom.isZoomed,
      currentProductId: state => state.productBar.currentProductId,
      productButtonFilterMap: state => state.filter.productButtonFilterMap,
      previousProductId: state => state.productBar.previousProductId
    })
  }
};
</script>

<style scoped lang="scss">
@import "../styles/_vars";
.animation-button {
  position: absolute;
  width: 10.5vw;
  height: 1.7vw;
  transform: translateX(0);
  z-index: 10;
  cursor: pointer;
  background-image: url("../assets/images/animation-button.svg");
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-content: center;
  align-items: center;
  &__title {
    font-size: 0.7vw;
  }
}
</style>
